import type {CorePlugin} from '../types'
import {variantsPlugin} from './variants'
import {defaultsPlugin} from './defaults'
import {rawExportPlugin} from './rawExport'
import {componentTypePlugin} from './componentType'
import {undefinedPlugin} from './undefined'
import {wixCodeConnectionPlugin} from './wixCodeConnection'
import {versionPlugin} from './version'
import {classicLayoutPlugin} from './classicLayout'
import {innerElementsMapPlugin} from './innerElementsMap'
import {beautifierPlugin} from './beautifier'

export const corePlugins: CorePlugin[] = [
    versionPlugin,
    undefinedPlugin,
    beautifierPlugin,
    defaultsPlugin,
    variantsPlugin,
    classicLayoutPlugin,
    rawExportPlugin,
    innerElementsMapPlugin,
    componentTypePlugin,
    wixCodeConnectionPlugin
]
